// extracted by mini-css-extract-plugin
export default {"global-warning":"TileImpactWarning_global-warning__5u5p6"};